module.exports = __webpack_public_path__ + "static/media/portfolio.ac3eabee.jpg";